import {EXPORT_FORMATS} from 'shared';

export const DEFAULT_CSV_EXPORT_PARAMS = {
    format: EXPORT_FORMATS.CSV,
    delValues: ';',
    delNumbers: '.',
    encoding: 'utf8',
};
